import { useEffect, useRef, useState } from 'react';

const useMountTransition = (mount: boolean, duration: number = 0.2) => {
  const [show, setShow] = useState(false);
  const timeoutRef = useRef<ReturnType<typeof setTimeout>>(null);

  useEffect(() => {
    if (mount) {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      setShow(true);
    } else {
      timeoutRef.current = setTimeout(() => {
        setShow(false);
      }, duration * 1000);
    }

    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, [mount]);

  return {
    shouldMount: mount || show,
    shouldFadeIn: mount && show,
  };
};

export default useMountTransition;
